<template>
	<div class="Referenzen">
		<div class="container">
			<h1>{{ $t('navigationReferenzen.title') }}</h1>
			<div class="row align-items-center h-50">
				<div class="py-5 col-9">
					<div>
						{{ $t('navigationReferenzen.description') }}
					</div>
				</div>
				<div class="py-5 ReferenzenPictures">
					<div class="Referenzen__Logos">
						<img src="@/assets/referenzen/Referenzen_DeutscherBundestag.jpg" />
						<img src="@/assets/referenzen/Referenzen_Ferrari.jpg" />
						<img src="@/assets/referenzen/Referenzen_FrankfurtAirport.jpg" />
						<img src="@/assets/referenzen/Referenzen_SecretService.jpg" />
					</div>
					<div class="Referenzen__Security">
						<img src="@/assets/referenzen/Referenzen_Security1.jpg" />
						<img src="@/assets/referenzen/Referenzen_Security2.jpg" />
						<img src="@/assets/referenzen/Referenzen_Security8.jpg" />

						<img src="@/assets/referenzen/Referenzen_Security13.jpg" />
						<img src="@/assets/referenzen/Referenzen_Security4.jpg" />

						<img src="@/assets/referenzen/Referenzen_Security11.jpg" />
						<img src="@/assets/referenzen/Referenzen_Security9.jpg" />

						<img src="@/assets/referenzen/Referenzen_Security5.jpg" />
						<img src="@/assets/referenzen/Referenzen_Security7.jpg" />
						<img src="@/assets/referenzen/Referenzen_Security10.jpg" />

						<img src="@/assets/referenzen/Referenzen_Security3.jpg" />
						<img src="@/assets/referenzen/Referenzen_Security12.jpg" />

						<img src="@/assets/referenzen/Referenzen_Security15.jpg" />
						<img src="@/assets/referenzen/Referenzen_Security6.jpg" />
						<img src="@/assets/referenzen/Referenzen_Security14.jpg" />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Referenzen',
	i18n: {
		messages: {
			de: require('@/i18n/de/de_referenzen.json'),
			en: require('@/i18n/en/eng_referenzen.json')
		}
	}
}
</script>

<style scoped lang="styl">
	.Referenzen__Logos {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;

	}
	.Referenzen__Logos > img {
		width: 18%;
		border: 1px rgba(255,255,255,0.6) solid;
		transition: transform .2s;
		background-color: rgba(11,38,46,0.8);
		padding: 5px;
	}

	.Referenzen__Security {
		display: flex;
		flex-wrap: wrap;
		margin-top: 35px;
	}

	.Referenzen__Security > img {
		width: 27%;
		height: auto;
		border: 1px rgba(255,255,255,0.6) solid;
		transition: transform .2s;
		background-color: rgba(11,38,46,0.8);
		padding: 5px;
	}

	.Referenzen__Security > img:hover, .Referenzen__Logos > img:hover {
    	transform: scale(1.4);
	}

@media only screen and (min-width: 768px) {
	.Referenzen__Security > img:nth-child(2) {
		width: 40%;
	}
	.Referenzen__Security > img:nth-child(3) {
		width: 33%;
	}
	.Referenzen__Security > img:nth-child(4) {
		width: 60%;
	}
	.Referenzen__Security > img:nth-child(5) {
		width: 40%;
	}
	.Referenzen__Security > img:nth-child(6) {
		width: 68%;
	}
	.Referenzen__Security > img:nth-child(7) {
		width: 32%;
	}
	.Referenzen__Security > img:nth-child(8) {
		width: 29%;
	}
	.Referenzen__Security > img:nth-child(9) {
		width: 29%;
	}
	.Referenzen__Security > img:nth-child(10) {
		width: 42%;
	}
	.Referenzen__Security > img:nth-child(11) {
		width: 68%;
	}
	.Referenzen__Security > img:nth-child(12) {
		width: 32%;
	}
	.Referenzen__Security > img:nth-child(13), .Referenzen__Security > img:nth-child(15) {
		width: 30%;
	}
	.Referenzen__Security > img:nth-child(14) {
		width: 40%;
	}
	}

	@media only screen and (min-width: 280px) and (max-width: 767px) and (max-height: 850px) {
		.Referenzen__Logos > img, .Referenzen__Security > img {
			width: 95%;
			margin-bottom: 10px;
		}
	}
</style>
